import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content" />
    </footer>
  );
}

export default Footer;

